import { FeatureScope } from "../core/auth/auth.entity";
import { useMyPanel } from "./useMyPanel";

export const useFeatureScopes = (feature: FeatureScope) => {
  const features = useMyPanel().feature_scopes;
  return Boolean(features && features.includes(feature));
};

export const useIsVip = () => {
  return useFeatureScopes(FeatureScope.SubmitCampaignAd);
};

export const useSponsoredMessages = () => {
  return useFeatureScopes(FeatureScope.SubmitSponsoredMessage) || true;
};
